import { ICard } from "../../types/card-type";

import "./style.scss";

type CardProps = {
	data: ICard;
};

export const Card = ({ data }: CardProps) => {
	const { link, description, icon, alt } = data;

	const content = (
		<div className="card-content">
			<img src={icon} alt={alt} />
			<p className="description">{description}</p>
		</div>
	);

	return link ? (
		<a href={link} className="card-description">
			{content}
		</a>
	) : (
		<div className="card-description">{content}</div>
	);
};

export default Card;
